module.exports = __webpack_public_path__ + "static/img/tap-left-1.2476b93.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/tap-left-1.png
// module id = 0MXA
// module chunks = 1